'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'tree';
var width = 448;
var height = 512;
var aliases = [127794];
var unicode = 'f1bb';
var svgPathData = ['M0 416l0 32 192 0 0-224 0-32 64 0 0 32 0 224 192 0 0-32-80-96 56 0 0-32-80-80 48 0 0-32L224 0 56 176l0 32 48 0L24 288l0 32 56 0L0 416z', 'M256 192l0 32 0 256 0 32-64 0 0-32 0-256 0-32 64 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTree = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;